import { Layout, ProgressBar } from "../components/funnel";
import { RegisteredHero } from "../components/registered/RegisteredHero";
import { NextSteps } from "../components/registered/NextSteps";
import { ToolkitCard } from "../components/registered/ToolkitCard";

export default function RegisteredPage() {
  return (
    <Layout chrome={false} footerVariant="compact">
      <ProgressBar label="YOU'RE REGISTERED" step="STEP 3 OF 3" percent={100} />
      <RegisteredHero />
      <NextSteps />
      <ToolkitCard />
    </Layout>
  );
}
